/**
 * WordPress dependencies.
 */
import { __ } from "@wordpress/i18n";
import { Panel, PanelBody, PanelRow, ToggleControl } from "@wordpress/components";
import { Fragment } from "@wordpress/element";

/**
 * Internal dependencies.
 */

const GeneralOption = ( { status, getOption, updateOption } ) => {
	// const { createNotice } = dispatch("core/notices");
	const Options = getOption();

	return (
		<Fragment>
			<PanelBody title={__("Purging options", "aruba-hispeed-cache")}>
				<PanelRow>
					<ToggleControl
						label={__("Enable automatic purge", "aruba-hispeed-cache")}
						help={__("Enable automatic purge", "aruba-hispeed-cache")}
						checked={Boolean(Options.ahsc_enable_purge)}
						disabled={"saving" === status}
						onChange={(e) => updateOption(Options, "ahsc_enable_purge", e)}
					/>
				</PanelRow>
			</PanelBody>

			<Panel header={__("Automatically purge entire cache when:", "aruba-hispeed-cache")}>
				<PanelBody title={__("Home page:", "aruba-hispeed-cache")}>
					<PanelRow>
						<ToggleControl
							label={__("a post (or page/custom post) is modified or added.", "aruba-hispeed-cache")}
							// help={__("helper.", "aruba-hispeed-cache")}
							checked={Boolean(Options.ahsc_purge_homepage_on_edit)}
							disabled={"saving" === status || Boolean(Options.ahsc_enable_purge) === false}
							onChange={(e) => updateOption(Options, "ahsc_purge_homepage_on_edit", e)}
						/>
					</PanelRow>
					<PanelRow>
						<ToggleControl
							label={__("a published post (or page/custom post) is cancelled.", "aruba-hispeed-cache")}
							// help={__("helper.", "aruba-hispeed-cache")}
							checked={Boolean(Options.ahsc_purge_homepage_on_del)}
							disabled={"saving" === status || Boolean(Options.ahsc_enable_purge) === false}
							onChange={(e) => updateOption(Options, "ahsc_purge_homepage_on_del", e)}
						/>
					</PanelRow>
				</PanelBody>

				<PanelBody title={__("Post/page/custom post type:", "aruba-hispeed-cache")}>
					<PanelRow>
						<ToggleControl
							label={__("a post is published.", "aruba-hispeed-cache")}
							// help={__("helper.", "aruba-hispeed-cache")}
							checked={Boolean(Options.ahsc_purge_page_on_mod)}
							disabled={"saving" === status || Boolean(Options.ahsc_enable_purge) === false}
							onChange={(e) => updateOption(Options, "ahsc_purge_page_on_mod", e)}
						/>
					</PanelRow>
					<PanelRow>
						<ToggleControl
							label={__("a comment is approved/published.", "aruba-hispeed-cache")}
							// help={__("Helper", "aruba-hispeed-cache")}
							checked={Boolean(Options.ahsc_purge_page_on_new_comment)}
							disabled={"saving" === status || Boolean(Options.ahsc_enable_purge) === false}
							onChange={(e) => updateOption(Options, "ahsc_purge_page_on_new_comment", e)}
						/>
					</PanelRow>
					<PanelRow>
						<ToggleControl
							label={__("a comment is unapproved/deleted.", "aruba-hispeed-cache")}
							// help={__("Helper", "aruba-hispeed-cache")}
							checked={Boolean(Options.ahsc_purge_page_on_deleted_comment)}
							disabled={"saving" === status || Boolean(Options.ahsc_enable_purge) === false}
							onChange={(e) => updateOption(Options, "ahsc_purge_page_on_deleted_comment", e)}
						/>
					</PanelRow>
				</PanelBody>

				<PanelBody title={__("Archives:", "aruba-hispeed-cache")}>
					<PanelRow>
						<ToggleControl
							label={__("a post (or page/custom post) is modified or added.", "aruba-hispeed-cache")}
							// help={__("Helper", "aruba-hispeed-cache")}
							checked={Boolean(Options.ahsc_purge_archive_on_edit)}
							disabled={"saving" === status || Boolean(Options.ahsc_enable_purge) === false}
							onChange={(e) => updateOption(Options, "ahsc_purge_archive_on_edit", e)}
						/>
					</PanelRow>
					<PanelRow>
						<ToggleControl
							label={__("a published post (or page/custom post) is cancelled.", "aruba-hispeed-cache")}
							// help={__("Helper", "aruba-hispeed-cache")}
							checked={Boolean(Options.ahsc_purge_archive_on_del)}
							disabled={"saving" === status || Boolean(Options.ahsc_enable_purge) === false}
							onChange={(e) => updateOption(Options, "ahsc_purge_archive_on_del", e)}
						/>
					</PanelRow>
				</PanelBody>

				<PanelBody title={__("Comments:", "aruba-hispeed-cache")}>
					<PanelRow>
						<ToggleControl
							label={__("a comment is approved/published.", "aruba-hispeed-cache")}
							// help={__("Helper", "aruba-hispeed-cache")}
							checked={Boolean(Options.ahsc_purge_archive_on_new_comment)}
							disabled={"saving" === status || Boolean(Options.ahsc_enable_purge) === false}
							onChange={(e) => updateOption(Options, "ahsc_purge_archive_on_new_comment", e)}
						/>
					</PanelRow>
					<PanelRow>
						<ToggleControl
							label={__("a comment is unapproved/deleted.", "aruba-hispeed-cache")}
							// help={__("Helper", "aruba-hispeed-cache")}
							checked={Boolean(Options.ahsc_purge_archive_on_deleted_comment)}
							disabled={"saving" === status || Boolean(Options.ahsc_enable_purge) === false}
							onChange={(e) => updateOption(Options, "ahsc_purge_archive_on_deleted_comment", e)}
						/>
					</PanelRow>
				</PanelBody>

				<PanelBody title={__("Cache Warming:", "aruba-hispeed-cache")}>
					<PanelRow>
						<ToggleControl
							label={__("Enables Cache Warming.", "aruba-hispeed-cache")}
							help={
								<>
								{__("Cache Warming is the process through which webpages are preloaded in the cache so they can be displayed quicker.", "aruba-hispeed-cache")}
									<br />
								{__("When the cache is emptied, the homepage data and the last ten posts of the site are automatically renewed, to guarantee faster loading webpages.", "aruba-hispeed-cache")}
							  	</>
							  }
							checked={Boolean(Options.ahsc_cache_warmer)}
							disabled={"saving" === status || Boolean(Options.ahsc_enable_purge) === false}
							onChange={(e) => updateOption(Options, "ahsc_cache_warmer", e)}
						/>
					</PanelRow>
				</PanelBody>

			</Panel>
		</Fragment>
	);
};

export default GeneralOption;
